<div style="position: relative;
top: 0%;
left: 1%;
width: 97%;">
<h2>{{'CURRENCY_RATE.TITLE' | translate}}</h2>

<ntr-datatable [data]="data" [metaInfo]="metaInfo" [entityTitle]="'currency-rate'" [modelView]="'currency-rates'"
               [disableHeader]="false"
               [actionButtons]="false"
               (onQuery)="onGridQuery($event)"
               [columns]="columns"
               [headers]="['Currency 1','Currency 2','Rate','Date','Source']">
</ntr-datatable>
</div>
